<template>
    <section id="main" class="main-viewport">
		<div class="subpage-banner py-4 img-only" style="background-image:url('images/banners/subpage-banner.jpg');">
			&nbsp;
		</div>
		<div class="subpage-content content-wrap mh-auto">
			<!-- Content start -->
			<div class="container py-4 text-container">
				<div class="row no-gutters">
					<div class="col-12 col-lg-10 offset-lg-1 pt-3">
						<div class="faq-content" v-html="content"></div>
            <section class="creator-faq" aria-labelledby="creator-faq-title">
              <h2 id="creator-faq-title">Creator Usage FAQ</h2>
              <div v-for="item in creatorFaq" :key="item.question" class="creator-faq__item">
                <h2>{{ item.question }}</h2>
                <p>{{ item.answer }}</p>
              </div>
            </section>
					</div>
				</div>
			</div>
			<!-- Content end -->
		</div>
        <SubFooter />
	</section>
</template>
<script>
import SubFooter from "../partials/SubFooter.vue";
import {mapActions} from "vuex";
import constant from "../../constants/constant";
import { faqRecommendations } from '../../content/seoGrowthContent';

export default {
    components: {
        SubFooter,
    },
  data(){
    return {
      MAIN_URL:'',
      content:'',
      creatorFaq: faqRecommendations
    }
  },
  async created() {
    this.main_url = constant.MAIN_URL;
    await this.getData();
  },
  methods:{
    ...mapActions({
      getContent:'content/getContent',
    }),
    async getData(){
      let payload = {
        url:this.main_url + '/api/content/faq',
      };
      const res = await this.getContent(payload);
      if(res.status == 200){
          this.content = this.normalizeFaqContent(res.data.content);
      }
    },
    normalizeFaqContent(html){
      if (!html || typeof window === 'undefined' || !window.DOMParser) {
        return html;
      }

      const parser = new window.DOMParser();
      const doc = parser.parseFromString(`<div>${html}</div>`, 'text/html');
      const wrapper = doc.body.firstElementChild;

      if (!wrapper) {
        return html;
      }

      wrapper.querySelectorAll('p').forEach((paragraph) => {
        const firstElement = Array.from(paragraph.childNodes).find((node) => {
          return node.nodeType === Node.ELEMENT_NODE || node.textContent.trim();
        });

        if (!firstElement || firstElement.nodeName.toLowerCase() !== 'strong') {
          return;
        }

        const question = firstElement.textContent.replace(/\s+/g, ' ').trim();

        if (!question.endsWith('?')) {
          return;
        }

        const heading = doc.createElement('h2');
        heading.className = 'faq-question-heading';
        heading.textContent = question;
        paragraph.parentNode.insertBefore(heading, paragraph);
        firstElement.remove();

        while (paragraph.firstChild && (
          (paragraph.firstChild.nodeType === Node.TEXT_NODE && !paragraph.firstChild.textContent.trim()) ||
          (paragraph.firstChild.nodeType === Node.ELEMENT_NODE && paragraph.firstChild.nodeName.toLowerCase() === 'br')
        )) {
          paragraph.firstChild.remove();
        }

        if (!paragraph.textContent.trim()) {
          paragraph.remove();
        }
      });

      return wrapper.innerHTML;
    }
  }
}
</script>

<style scoped>
.creator-faq {
  border-top: 1px solid rgba(0,0,0,0.08);
  margin-top: 32px;
  padding-top: 26px;
}
.creator-faq h2 {
  font-size: 28px;
  margin-bottom: 20px;
}
.creator-faq__item {
  margin-bottom: 20px;
}
.creator-faq__item h2 {
  font-size: 18px;
  margin-bottom: 8px;
}
.creator-faq__item p {
  line-height: 1.7;
}
</style>

<style>
.faq-content .faq-question-heading {
  font-size: 22px;
  line-height: 1.35;
  margin: 0 0 10px;
}
</style>
